import { render, staticRenderFns } from "./CoachAthleteReportsSummary.vue?vue&type=template&id=35d3b87a&"
import script from "./CoachAthleteReportsSummary.vue?vue&type=script&lang=ts&"
export * from "./CoachAthleteReportsSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports